// (C) Copyright 2020 MediaWink, LLC

export const SET_TOUR = 'SET_TOUR';
